import { render, staticRenderFns } from "./EventsLogSettings.vue?vue&type=template&id=1d5b0017&scoped=true&"
import script from "./EventsLogSettings.vue?vue&type=script&lang=js&"
export * from "./EventsLogSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b0017",
  null
  
)

export default component.exports